<svg
  width="199"
  height="153"
  viewBox="0 0 199 153"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M90.8863 130.339C89.5383 125.847 84.0093 123.15 78.7073 121.702C73.4053 120.254 67.6343 119.461 63.2403 116.605C57.0223 112.563 55.1783 105.496 54.2573 98.9903C53.3363 92.4843 27.1004 100.873 22.3204 95.6574C17.1034 89.9648 33.7473 72.3388 27.2403 67.6461C19.8103 62.2876 16.0583 53.4013 18.6903 45.5331C21.3233 37.6657 30.6593 31.4922 40.5003 31.7973C47.8263 32.0245 54.6453 35.4811 61.9763 35.4156C71.7313 35.3285 79.6803 29.1782 86.3623 23.2858C93.0453 17.3925 100.418 10.9645 110.108 10.0284C118.908 9.17778 127.49 13.2611 133.476 18.676C139.462 24.0908 143.445 30.7759 148.046 37.0539C152.647 43.331 158.222 49.4821 166.114 52.8192C172.841 55.6631 181.404 56.6273 185.572 61.8482C189.79 67.132 187.208 74.5508 182.102 79.2651C176.996 83.9794 169.912 86.81 163.492 90.2482C157.072 93.6865 150.835 98.293 149.227 104.488C147.717 110.306 150.581 116.53 148.58 122.245C146.082 129.378 137.102 134.46 130.931 139.363C126.022 143.264 121.199 148.654 114.946 151.141C109.06 153.483 101.234 152.283 96.0193 149.146C87.3693 143.942 92.9783 137.278 90.8863 130.339Z"
    fill="url(#paint0_linear_2647_40717)"
  />
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M172.059 77.5112C172.059 77.9132 171.733 78.2392 171.331 78.2392C170.929 78.2392 170.603 77.9132 170.603 77.5112C170.603 77.1092 170.929 76.7832 171.331 76.7832C171.733 76.7832 172.059 77.1092 172.059 77.5112Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M159.883 67.7246C160.217 67.7246 160.488 67.4538 160.488 67.1197C160.488 66.7855 160.217 66.5146 159.883 66.5146C159.549 66.5146 159.278 66.7855 159.278 67.1197C159.278 67.4538 159.549 67.7246 159.883 67.7246Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M141.8 70.0715C141.8 70.3285 141.592 70.5365 141.334 70.5365C141.076 70.5365 140.869 70.3285 140.869 70.0715C140.869 69.8145 141.077 69.6055 141.334 69.6055C141.591 69.6055 141.8 69.8135 141.8 70.0715Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M133.192 72.7938C133.616 72.7938 133.959 72.4504 133.959 72.0268C133.959 71.6032 133.616 71.2598 133.192 71.2598C132.768 71.2598 132.425 71.6032 132.425 72.0268C132.425 72.4504 132.768 72.7938 133.192 72.7938Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M128.849 86.5079C128.849 86.7629 128.642 86.9699 128.387 86.9699C128.132 86.9699 127.925 86.7629 127.925 86.5079C127.925 86.2529 128.132 86.0459 128.387 86.0459C128.642 86.0459 128.849 86.2529 128.849 86.5079Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M116.744 78.5555C116.744 78.8515 116.504 79.0915 116.208 79.0915C115.912 79.0915 115.672 78.8515 115.672 78.5555C115.672 78.2595 115.912 78.0195 116.208 78.0195C116.504 78.0195 116.744 78.2595 116.744 78.5555Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M119.762 82.6412C119.762 82.9322 119.527 83.1672 119.236 83.1672C118.945 83.1672 118.71 82.9322 118.71 82.6412C118.71 82.3502 118.946 82.1152 119.236 82.1152C119.526 82.1152 119.762 82.3502 119.762 82.6412Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M119.085 82.5299C119.085 82.8209 118.849 83.0559 118.559 83.0559C118.269 83.0559 118.033 82.8199 118.033 82.5299C118.033 82.2399 118.269 82.0039 118.559 82.0039C118.849 82.0039 119.085 82.2399 119.085 82.5299Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M116.002 88.0713C116.002 88.4863 115.666 88.8223 115.251 88.8223C114.836 88.8223 114.5 88.4863 114.5 88.0713C114.5 87.6563 114.836 87.3203 115.251 87.3203C115.666 87.3203 116.002 87.6563 116.002 88.0713Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M103.868 67.2005C104.159 67.2005 104.395 66.9645 104.395 66.6735C104.395 66.3824 104.159 66.1465 103.868 66.1465C103.577 66.1465 103.341 66.3824 103.341 66.6735C103.341 66.9645 103.577 67.2005 103.868 67.2005Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M108.063 70.0129C108.063 70.2929 107.836 70.5209 107.555 70.5209C107.274 70.5209 107.047 70.2939 107.047 70.0129C107.047 69.7319 107.274 69.5049 107.555 69.5049C107.836 69.5049 108.063 69.7319 108.063 70.0129Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M114.167 77.5081C114.167 77.8831 113.863 78.1861 113.489 78.1861C113.115 78.1861 112.811 77.8821 112.811 77.5081C112.811 77.1341 113.115 76.8301 113.489 76.8301C113.863 76.8301 114.167 77.1341 114.167 77.5081Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M113.882 58.403C114.165 58.403 114.395 58.1733 114.395 57.89C114.395 57.6066 114.165 57.377 113.882 57.377C113.599 57.377 113.369 57.6066 113.369 57.89C113.369 58.1733 113.599 58.403 113.882 58.403Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M109.386 50.5311C109.764 50.5311 110.07 50.2248 110.07 49.8471C110.07 49.4693 109.764 49.1631 109.386 49.1631C109.008 49.1631 108.702 49.4693 108.702 49.8471C108.702 50.2248 109.008 50.5311 109.386 50.5311Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M112.287 40.0518C112.287 40.4438 111.969 40.7608 111.577 40.7608C111.185 40.7608 110.867 40.4428 110.867 40.0518C110.867 39.6608 111.185 39.3418 111.577 39.3418C111.969 39.3418 112.287 39.6598 112.287 40.0518Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M106.864 41.8378C107.174 41.8378 107.425 41.5866 107.425 41.2768C107.425 40.967 107.174 40.7158 106.864 40.7158C106.554 40.7158 106.303 40.967 106.303 41.2768C106.303 41.5866 106.554 41.8378 106.864 41.8378Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M111.02 17.1801C111.02 17.4661 110.788 17.6971 110.503 17.6971C110.218 17.6971 109.986 17.4651 109.986 17.1801C109.986 16.8951 110.218 16.6631 110.503 16.6631C110.788 16.6631 111.02 16.8951 111.02 17.1801Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M112.396 53.8752C112.396 54.1792 112.15 54.4252 111.846 54.4252C111.542 54.4252 111.296 54.1792 111.296 53.8752C111.296 53.5712 111.542 53.3252 111.846 53.3252C112.15 53.3252 112.396 53.5712 112.396 53.8752Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M96.084 52.5934C96.084 52.9304 95.811 53.2034 95.474 53.2034C95.137 53.2034 94.864 52.9304 94.864 52.5934C94.864 52.2564 95.137 51.9834 95.474 51.9834C95.811 51.9834 96.084 52.2564 96.084 52.5934Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M94.52 43.3335C94.52 43.6215 94.287 43.8545 93.999 43.8545C93.711 43.8545 93.478 43.6215 93.478 43.3335C93.478 43.0455 93.711 42.8125 93.999 42.8125C94.287 42.8125 94.52 43.0455 94.52 43.3335Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M82.463 61.9912C82.463 62.3812 82.147 62.6972 81.757 62.6972C81.367 62.6972 81.052 62.3812 81.052 61.9912C81.052 61.6012 81.368 61.2852 81.757 61.2852C82.146 61.2852 82.463 61.6012 82.463 61.9912Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M74.756 44.1949C74.756 44.6219 74.41 44.9689 73.982 44.9689C73.554 44.9689 73.208 44.6229 73.208 44.1949C73.208 43.7669 73.554 43.4209 73.982 43.4209C74.41 43.4209 74.756 43.7669 74.756 44.1949Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M73.6689 49.6191C73.6689 49.9871 73.3709 50.2861 73.0029 50.2861C72.6349 50.2861 72.3359 49.9881 72.3359 49.6191C72.3359 49.2501 72.6339 48.9531 73.0029 48.9531C73.3719 48.9531 73.6689 49.2511 73.6689 49.6191Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M73.2018 47.6495C73.2018 48.0195 72.9018 48.3195 72.5318 48.3195C72.1618 48.3195 71.8618 48.0195 71.8618 47.6495C71.8618 47.2795 72.1618 46.9795 72.5318 46.9795C72.9018 46.9795 73.2018 47.2795 73.2018 47.6495Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M54.9249 42.359C54.9249 42.742 54.6139 43.053 54.2309 43.053C53.8479 43.053 53.5369 42.742 53.5369 42.359C53.5369 41.976 53.8469 41.665 54.2309 41.665C54.6149 41.665 54.9249 41.976 54.9249 42.359Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M58.2101 57.861C58.2101 58.153 57.9741 58.389 57.6821 58.389C57.3901 58.389 57.1541 58.153 57.1541 57.861C57.1541 57.569 57.3901 57.333 57.6821 57.333C57.9741 57.333 58.2101 57.569 58.2101 57.861Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M52.4579 53.2393C52.4579 53.5403 52.2139 53.7843 51.9129 53.7843C51.6119 53.7843 51.3679 53.5403 51.3679 53.2393C51.3679 52.9383 51.6119 52.6943 51.9129 52.6943C52.2139 52.6943 52.4579 52.9383 52.4579 53.2393Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M51.205 51.956C51.205 52.255 50.963 52.497 50.664 52.497C50.365 52.497 50.123 52.255 50.123 51.956C50.123 51.657 50.365 51.415 50.664 51.415C50.963 51.415 51.205 51.657 51.205 51.956Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M45.4589 53.7532C45.4589 54.0592 45.2109 54.3082 44.9039 54.3082C44.5969 54.3082 44.3489 54.0602 44.3489 53.7532C44.3489 53.4462 44.5969 53.1982 44.9039 53.1982C45.2109 53.1982 45.4589 53.4462 45.4589 53.7532Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M44.3919 57.2365C44.3919 57.6315 44.0719 57.9515 43.6769 57.9515C43.2819 57.9515 42.9619 57.6315 42.9619 57.2365C42.9619 56.8415 43.2819 56.5215 43.6769 56.5215C44.0719 56.5215 44.3919 56.8415 44.3919 57.2365Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M37.5589 63.2216C37.5589 63.4956 37.3369 63.7186 37.0619 63.7186C36.7869 63.7186 36.5649 63.4966 36.5649 63.2216C36.5649 62.9466 36.7869 62.7246 37.0619 62.7246C37.3369 62.7246 37.5589 62.9466 37.5589 63.2216Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M38.1678 62.1072C38.5329 62.1072 38.8288 61.8112 38.8288 61.4462C38.8288 61.0811 38.5329 60.7852 38.1678 60.7852C37.8028 60.7852 37.5068 61.0811 37.5068 61.4462C37.5068 61.8112 37.8028 62.1072 38.1678 62.1072Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M40.735 64.8221C41.067 64.8221 41.336 64.553 41.336 64.2211C41.336 63.8892 41.067 63.6201 40.735 63.6201C40.4031 63.6201 40.134 63.8892 40.134 64.2211C40.134 64.553 40.4031 64.8221 40.735 64.8221Z"
      fill="#FCFDFD"
    />
  </g>
  <g style="mix-blend-mode: color-dodge">
    <path
      d="M43.5429 55.1264C43.5429 55.5514 43.1989 55.8954 42.7739 55.8954C42.3489 55.8954 42.0049 55.5514 42.0049 55.1264C42.0049 54.7014 42.3489 54.3574 42.7739 54.3574C43.1989 54.3574 43.5429 54.7014 43.5429 55.1264Z"
      fill="#FCFDFD"
    />
  </g>
  <path
    d="M159.975 77.6066C159.975 53.8326 140.702 34.5596 116.928 34.5596C101.343 34.5596 87.6929 42.8426 80.1389 55.2456C77.4139 54.1726 74.4489 53.5766 71.3429 53.5766C58.0719 53.5766 47.3129 64.3356 47.3129 77.6066C32.3909 77.6066 20.3429 89.9076 20.7539 104.923C21.1509 119.395 33.3879 130.745 47.8649 130.745H83.1859C87.6709 130.745 91.3069 127.109 91.3069 122.624V105.248C91.3069 102.921 89.3949 101.145 87.0679 101.098C83.8389 101.033 81.9089 97.4416 83.6679 94.7056L100.154 69.0646C101.787 66.5246 105.501 66.5246 107.134 69.0646L123.62 94.7056C125.379 97.4416 123.449 101.033 120.22 101.098C117.894 101.145 115.981 102.921 115.981 105.248V122.624C115.981 127.109 119.617 130.745 124.102 130.745H159.423C173.9 130.745 186.137 119.394 186.534 104.923C186.946 89.9076 174.897 77.6066 159.975 77.6066Z"
    fill="url(#paint1_linear_2647_40717)"
  />
  <path
    d="M20.7669 105.181C21.2819 90.9596 32.9659 79.5876 47.3119 79.5876C47.3119 66.3166 58.0709 55.5576 71.3419 55.5576C74.4479 55.5576 77.4129 56.1536 80.1379 57.2266C87.6929 44.8236 101.342 36.5406 116.927 36.5406C140.701 36.5406 159.974 55.8136 159.974 79.5876C174.32 79.5876 186.004 90.9596 186.519 105.181C186.522 105.094 186.53 105.009 186.533 104.922C186.945 89.9066 174.896 77.6056 159.974 77.6056C159.974 53.8316 140.701 34.5586 116.927 34.5586C101.342 34.5586 87.6919 42.8416 80.1379 55.2446C77.4129 54.1716 74.4479 53.5756 71.3419 53.5756C58.0709 53.5756 47.3119 64.3346 47.3119 77.6056C32.3899 77.6056 20.3419 89.9066 20.7529 104.922C20.7549 105.009 20.7639 105.094 20.7669 105.181Z"
    fill="#90D0FF"
  />
  <path
    d="M120.219 101.097C117.893 101.144 115.98 102.92 115.98 105.247V107.229C115.98 104.902 117.892 103.126 120.219 103.079C122.969 103.023 124.768 100.411 124.157 97.9473C123.725 99.6573 122.223 101.057 120.219 101.097Z"
    fill="#81E7EE"
  />
  <path
    d="M87.0678 101.097C85.0628 101.056 83.5608 99.6573 83.1298 97.9473C82.5188 100.411 84.3178 103.023 87.0678 103.079C89.3938 103.126 91.3068 104.902 91.3068 107.229V105.247C91.3068 102.92 89.3948 101.144 87.0678 101.097Z"
    fill="#81E7EE"
  />
  <path
    d="M186.534 104.921C186.137 119.393 173.9 130.743 159.423 130.743H124.102C119.617 130.743 115.981 127.107 115.981 122.622V130.796C115.981 135.281 119.617 138.917 124.102 138.917H159.423C173.9 138.917 186.138 127.567 186.534 113.095H186.544V104.921H186.534Z"
    fill="#1564C1"
  />
  <path
    d="M83.186 130.743H47.865C33.388 130.743 21.151 119.392 20.754 104.921V111.648C20.742 112.127 20.741 112.609 20.754 113.095C21.151 127.567 33.388 138.917 47.865 138.917H83.186C87.671 138.917 91.307 135.281 91.307 130.796V122.622C91.307 127.107 87.671 130.743 83.186 130.743Z"
    fill="#1564C1"
  />
  <path
    d="M123.619 94.7052L107.133 69.0642C105.5 66.5242 101.786 66.5242 100.153 69.0642L83.667 94.7052C82.297 96.8362 83.17 99.4782 85.147 100.577L100.153 77.2382C101.786 74.6982 105.5 74.6982 107.133 77.2382L122.139 100.577C124.116 99.4792 124.989 96.8362 123.619 94.7052Z"
    fill="#1564C1"
  />
  <path
    d="M93.0959 105.248V146.629"
    stroke="#59AFFF"
    stroke-miterlimit="10"
    stroke-linecap="round"
  />
  <path
    d="M114.191 105.248V146.629"
    stroke="#59AFFF"
    stroke-miterlimit="10"
    stroke-linecap="round"
  />
  <path
    d="M103.643 152.368L103.643 121.002"
    stroke="#7DC0FF"
    stroke-miterlimit="10"
    stroke-linecap="round"
  />
  <path
    d="M53.8272 148.338C76.2552 138.753 73.5552 116.287 73.5552 116.287C73.5552 116.287 66.5922 109.872 53.8272 109.049C41.0622 109.872 34.0992 116.287 34.0992 116.287C34.0992 116.287 31.3992 138.753 53.8272 148.338Z"
    fill="url(#paint2_linear_2647_40717)"
  />
  <path
    d="M53.8283 145.134C37.5353 137.493 36.8053 122.063 36.9353 117.767C39.0193 116.243 44.8613 112.604 53.8273 111.979C62.8003 112.604 68.6443 116.247 70.7293 117.775C70.8953 122.11 70.2523 137.444 53.8283 145.134Z"
    fill="url(#paint3_linear_2647_40717)"
  />
  <path
    d="M54.8703 120.198L56.1033 123.994C56.2503 124.446 56.6713 124.752 57.1463 124.752H61.1373C62.1993 124.752 62.6413 126.111 61.7813 126.735L58.5523 129.081C58.1683 129.36 58.0073 129.855 58.1543 130.307L59.3873 134.103C59.7153 135.113 58.5593 135.953 57.7003 135.329L54.4713 132.983C54.0873 132.704 53.5663 132.704 53.1823 132.983L49.9533 135.329C49.0943 135.953 47.9383 135.113 48.2663 134.103L49.4993 130.307C49.6463 129.855 49.4853 129.36 49.1013 129.081L45.8723 126.735C45.0133 126.111 45.4543 124.752 46.5163 124.752H50.5073C50.9823 124.752 51.4033 124.446 51.5503 123.994L52.7833 120.198C53.1113 119.188 54.5403 119.188 54.8683 120.198H54.8703Z"
    fill="#FCFDFA"
  />
  <path
    d="M190.445 114.276C190.71 113.867 190.967 113.453 191.22 113.036"
    stroke="#2FB4FF"
    stroke-width="0.5"
    stroke-miterlimit="10"
  />
  <path
    d="M192.656 110.495C199.833 96.8768 200.675 80.1275 194.683 65.9449C192.197 60.061 188.339 54.379 182.516 51.5477C176.693 48.7165 168.651 49.6482 164.964 54.8933C161.278 60.1384 164.728 69.0818 171.225 69.3012C175.188 69.4345 178.748 66.5229 180.438 63.0088C182.128 59.4948 182.302 55.4811 182.256 51.5967C182.177 44.7077 181.285 37.3005 176.606 32.1563C169.611 24.4669 157.27 24.9136 147.023 27.2236C136.776 29.5327 125.94 33.0654 116.06 29.5396C107.881 26.6211 102.221 19.4716 95.578 13.9629C80.8216 1.72787 59.5758 -2.52779 41.1001 3.04944C22.6245 8.62765 7.5109 23.8605 2.34792 42.1096C-2.55326 59.4301 1.65875 78.9401 13.1359 92.9337"
    stroke="#2FB4FF"
    stroke-width="0.5"
    stroke-miterlimit="10"
  />
  <path
    d="M14.0728 94.0488C14.3913 94.4162 14.7138 94.7787 15.043 95.1372"
    stroke="#2FB4FF"
    stroke-width="0.5"
    stroke-miterlimit="10"
  />
  <defs>
    <linearGradient
      id="paint0_linear_2647_40717"
      x1="102.768"
      y1="91.3949"
      x2="102.768"
      y2="-70.6441"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#55B8FF" stop-opacity="0" />
      <stop offset="1" stop-color="#42BBFF" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_2647_40717"
      x1="23.355"
      y1="82.6521"
      x2="186.544"
      y2="82.6521"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#237CE4" />
      <stop offset="1" stop-color="#53A2FF" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_2647_40717"
      x1="53.8272"
      y1="95.5758"
      x2="53.8272"
      y2="324.407"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FCFDFA" />
      <stop offset="1" stop-color="#837BFF" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_2647_40717"
      x1="53.8353"
      y1="144.666"
      x2="53.8353"
      y2="89.8535"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#50A9FB" />
      <stop offset="1" stop-color="#1D80B8" />
    </linearGradient>
  </defs>
</svg>
